import { style, styleVariants, keyframes } from '@vanilla-extract/css'
import { vars, dot as dotBase } from '../design/theme.css'
import { reading as readingVoice } from '../design/primitives/text.css'

// The shared ALMANAC treatment — one consistent look for every almanac reading (Live's ambient
// row, in the same muted line-icon language the Journal record uses). A reading is a muted Tabler
// line-icon + a mono label; the moon alone is drawn to its real phase. Icon size + colour come
// from the shared mark tokens, so the Journal record's icons cannot drift from these again.

export const row = style([
  readingVoice,
  {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: `${vars.space[3]} ${vars.space[6]}`,
    margin: 0,
    padding: `${vars.space[3]} 0`,
    listStyle: 'none',
    color: vars.color.ink2,
    '@media': {
      'screen and (max-width: 560px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: vars.space[3],
      },
    },
  },
])
export const reading = style({ display: 'inline-flex', alignItems: 'center', gap: vars.space[2] })
export const icon = style({
  fontSize: vars.mark.icon,
  color: vars.color.inkSoft,
  lineHeight: 1,
  flex: 'none',
})
export const moon = style({
  width: vars.mark.icon,
  height: vars.mark.icon,
  flex: 'none',
  color: vars.color.inkSoft,
})
export const status = style([reading, { color: vars.color.ink }])

const pulse = keyframes({ '0%,100%': { opacity: 1 }, '50%': { opacity: 0.3 } })
export const dot = styleVariants({
  listening: {
    ...dotBase,
    background: vars.color.green,
    animation: `${pulse} 2.4s ease-in-out infinite`,
    '@media': { '(prefers-reduced-motion: reduce)': { animation: 'none' } },
  },
  offline: { ...dotBase, background: vars.color.red },
})
